import React from 'react';
import { useTranslation } from 'react-i18next';

// Import client logos
import Suzuki from '../images/clients/Suzuki.svg';
import rbs from '../images/clients/robot-service.png';
import conti from '../images/clients/conti.png';
import joyson from '../images/clients/joyson.png';
import denso from '../images/clients/denso.svg';
import haldex from '../images/clients/haldex.svg';

const Clients = () => {
    const { t } = useTranslation();

    // An array to easily manage your client logos
    const clientLogos = [
        { name: 'Suzuki', logo: Suzuki },
        { name: 'Continental', logo: conti },
        { name: 'Robot-Service', logo: rbs },
        { name: 'Joyson Safety Systems', logo: joyson },
        { name: 'DENSO', logo: denso },
        { name: 'Haldex', logo: haldex }
    ];

    return (
        <div className="bg-gray-100" id="clients">
            <section data-aos="fade-up" className="py-12">
                <div className="my-4 py-4">
                    {/* Color class updated here */}
                    <h2 className="my-2 text-center text-3xl text-primary uppercase font-bold">
                        {t('clients.title')}
                    </h2>
                    <div className='flex justify-center'>
                        {/* Color class updated here */}
                        <div className='w-24 border-b-4 border-primary'></div>
                    </div>
                    <p className="mt-4 mx-auto max-w-2xl text-center text-xl lg:text-2xl font-semibold text-gray-600">
                        {t('clients.subtitle')}
                    </p>
                </div>

                <div className="max-w-6xl mx-auto p-8" data-aos="fade-in" data-aos-delay="300">
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-12 items-center">
                        
                        {clientLogos.map((client, index) => (
                            <div key={index} className="flex justify-center items-center">
                                <img 
                                    src={client.logo} 
                                    alt={client.name} 
                                    loading="lazy"
                                    decoding="async"
                                    className="h-20 w-auto object-contain transition-all duration-300 ease-in-out" 
                                />
                            </div>
                        ))}
                                           
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Clients;